"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubscriptionAPIClient = void 0;
var graphql_request_1 = require("graphql-request");
var whatwg_url_1 = require("whatwg-url");
var subscriptionAPIGraphqlClient = null;
/**
 * Initiate a graphQLClient if none already exists.
 * Otherwise return the graphql client that has already been initiated
 */
var getSubscriptionAPIClient = function () {
    var _a;
    if (subscriptionAPIGraphqlClient)
        return subscriptionAPIGraphqlClient;
    var query = new whatwg_url_1.URLSearchParams(window.location.search);
    var rhash = query.get('rhash');
    var customerHash = rhash || ((_a = window.customer) === null || _a === void 0 ? void 0 : _a.rechargeHash);
    var headers = {
        'X-Recharge-Customer-Hash': customerHash || '',
        'X-Shopify-Domain': process.env.PERMANENT_DOMAIN || window.permanentDomain || '',
    };
    subscriptionAPIGraphqlClient = new graphql_request_1.GraphQLClient("".concat(process.env.SUBSCRIPTIONS_API_URL, "/graphql"), {
        headers: headers,
    });
    return subscriptionAPIGraphqlClient;
};
exports.getSubscriptionAPIClient = getSubscriptionAPIClient;
